export const GHL_REQUIRED_CUSTOM_FIELDS: string[] = [
  'ss_advertisingintelligence',
  'ss_alexascore',
  'ss_businessemail',
  'ss_company',
  'ss_companyannualrevenue',
  'ss_companydescription',
  'ss_companydomain',
  'ss_companyfounded',
  'ss_companyfundingtotal',
  'ss_companyid',
  'ss_companyindustries_list',
  'ss_companyindustry',
  'ss_companylatestfundingdate',
  'ss_companylinkedinid',
  'ss_companyliprofileurl',
  'ss_companylocation_city',
  'ss_companylocation_country',
  'ss_companylocation_countryabbr',
  'ss_companylocation_countryalpha2',
  'ss_companylocation_countryalpha3',
  'ss_companylocation_countrynumeric',
  'ss_companylocation_fullstring',
  'ss_companylocation_id',
  'ss_companylocation_postcode',
  'ss_companylocation_state',
  'ss_companylocation_stateabbr',
  'ss_companylocation_street1',
  'ss_companylocation_street2',
  'ss_companynaicscode',
  'ss_companynaicsdesc',
  'ss_companyname',
  'ss_companynews',
  'ss_companyoriginal',
  'ss_companyphone1',
  'ss_companyphone10',
  'ss_companyphone10datatype',
  'ss_companyphone10totalai',
  'ss_companyphone1datatype',
  'ss_companyphone1id',
  'ss_companyphone1totalai',
  'ss_companyphone2',
  'ss_companyphone2datatype',
  'ss_companyphone2totalai',
  'ss_companyphone3',
  'ss_companyphone3datatype',
  'ss_companyphone3totalai',
  'ss_companyphone4',
  'ss_companyphone4datatype',
  'ss_companyphone4totalai',
  'ss_companyphone5',
  'ss_companyphone5datatype',
  'ss_companyphone5totalai',
  'ss_companyphone6',
  'ss_companyphone6datatype',
  'ss_companyphone6totalai',
  'ss_companyphone7',
  'ss_companyphone7datatype',
  'ss_companyphone7totalai',
  'ss_companyphone8',
  'ss_companyphone8datatype',
  'ss_companyphone8totalai',
  'ss_companyphone9',
  'ss_companyphone9datatype',
  'ss_companyphone9totalai',
  'ss_companyrevenuerange',
  'ss_companysiccode',
  'ss_companysicdesc',
  'ss_companystaffcount',
  'ss_companystaffcountrange',
  'ss_companytechnologies_list',
  'ss_companytechnologiescount',
  'ss_companytype',
  'ss_contactlocation_city',
  'ss_contactlocation_country',
  'ss_contactlocation_countryabbr',
  'ss_contactlocation_countryalpha2',
  'ss_contactlocation_countryalpha3',
  'ss_contactlocation_countrynumeric',
  'ss_contactlocation_fullstring',
  'ss_contactlocation_id',
  'ss_contactlocation_postcode',
  'ss_contactlocation_state',
  'ss_contactlocation_stateabbr',
  'ss_contactlocation_timezone',
  'ss_contactlocation_timezoneabbr',
  'ss_contactlocation_timezonerawoffset',
  'ss_contactmobilephone1',
  'ss_contactmobilephone1datatype',
  'ss_contactmobilephone1totalai',
  'ss_contactmobilephone2',
  'ss_contactmobilephone2datatype',
  'ss_contactmobilephone2totalai',
  'ss_contactmobilephone3',
  'ss_contactmobilephone3datatype',
  'ss_contactmobilephone3totalai',
  'ss_contactmobilephone4',
  'ss_contactmobilephone4datatype',
  'ss_contactmobilephone4totalai',
  'ss_contactmobilephone5',
  'ss_contactmobilephone5datatype',
  'ss_contactmobilephone5totalai',
  'ss_contactmobilephone6',
  'ss_contactmobilephone6datatype',
  'ss_contactmobilephone6totalai',
  'ss_contactphone1',
  'ss_contactphone10',
  'ss_contactphone10datatype',
  'ss_contactphone10totalai',
  'ss_contactphone1datatype',
  'ss_contactphone1totalai',
  'ss_contactphone2',
  'ss_contactphone2datatype',
  'ss_contactphone2totalai',
  'ss_contactphone3',
  'ss_contactphone3datatype',
  'ss_contactphone3totalai',
  'ss_contactphone4',
  'ss_contactphone4datatype',
  'ss_contactphone4totalai',
  'ss_contactphone5',
  'ss_contactphone5datatype',
  'ss_contactphone5totalai',
  'ss_contactphone6',
  'ss_contactphone6datatype',
  'ss_contactphone6totalai',
  'ss_contactphone7',
  'ss_contactphone7datatype',
  'ss_contactphone7totalai',
  'ss_contactphone8',
  'ss_contactphone8datatype',
  'ss_contactphone8totalai',
  'ss_contactphone9',
  'ss_contactphone9datatype',
  'ss_contactphone9totalai',
  'ss_created_at',
  'ss_createdat',
  'ss_crunchbase_ds_list',
  'ss_crunchbase_scraped_at',
  'ss_dedupe_key',
  'ss_department',
  'ss_domain',
  'ss_email',
  'ss_email1',
  'ss_email10',
  'ss_email10emailai',
  'ss_email10id',
  'ss_email10totalai',
  'ss_email10userai',
  'ss_email1emailai',
  'ss_email1id',
  'ss_email1selected',
  'ss_email1totalai',
  'ss_email1userai',
  'ss_email2',
  'ss_email2emailai',
  'ss_email2id',
  'ss_email2totalai',
  'ss_email2userai',
  'ss_email3',
  'ss_email3emailai',
  'ss_email3id',
  'ss_email3totalai',
  'ss_email3userai',
  'ss_email4',
  'ss_email4emailai',
  'ss_email4id',
  'ss_email4totalai',
  'ss_email4userai',
  'ss_email5',
  'ss_email5emailai',
  'ss_email5id',
  'ss_email5totalai',
  'ss_email5userai',
  'ss_email6',
  'ss_email6emailai',
  'ss_email6id',
  'ss_email6totalai',
  'ss_email6userai',
  'ss_email7',
  'ss_email7emailai',
  'ss_email7id',
  'ss_email7totalai',
  'ss_email7userai',
  'ss_email8',
  'ss_email8emailai',
  'ss_email8id',
  'ss_email8totalai',
  'ss_email8userai',
  'ss_email9',
  'ss_email9emailai',
  'ss_email9id',
  'ss_email9totalai',
  'ss_email9userai',
  'ss_emaildomain',
  'ss_employeereviews',
  'ss_entity_id',
  'ss_firstname',
  'ss_full_name',
  'ss_fullname',
  'ss_glassdoor_benefits_ds_list',
  'ss_glassdoor_interviews_ds_list',
  'ss_glassdoor_overview_ds_list',
  'ss_glassdoor_reviews_ds_list',
  'ss_glassdoor_salaries_ds_list',
  'ss_glassdoor_scraped_at',
  'ss_googlefinance',
  'ss_googleresearch',
  'ss_id',
  'ss_image',
  'ss_isarchived',
  'ss_isresearching',
  'ss_jobpostings',
  'ss_lastname',
  'ss_linkedin_employees_ds_list',
  'ss_linkedin_jobs_ds_list',
  'ss_linkedin_posts_ds_list',
  'ss_linkedin_profile_ds_list',
  'ss_linkedin_scraped_at',
  'ss_linkedin_url',
  'ss_liprofileurl',
  'ss_lirecruiterurl',
  'ss_lisalesnavurl',
  'ss_localsportsteams',
  'ss_localweather',
  'ss_middlename',
  'ss_name',
  'ss_nameoriginal',
  'ss_ownerfirstname',
  'ss_ownerlastname',
  'ss_paidsearchintelligence',
  'ss_paidsearchkeywordsintelligence',
  'ss_personalemail',
  'ss_personalemail1',
  'ss_personalemail1emailai',
  'ss_personalemail1id',
  'ss_personalemail1selected',
  'ss_personalemail1totalai',
  'ss_personalemail1userai',
  'ss_personalemail2',
  'ss_personalemail2emailai',
  'ss_personalemail2id',
  'ss_personalemail2totalai',
  'ss_personalemail2userai',
  'ss_probe_field',
  'ss_prospectstatus',
  'ss_prospectstatusemoji',
  'ss_prospectstatusid',
  'ss_reresearchable',
  'ss_researchedat',
  'ss_searchmarketingintelligence',
  'ss_searchresultid',
  'ss_secfilings',
  'ss_seniority',
  'ss_seoresearch',
  'ss_similarwebsites',
  'ss_socialmediamentions',
  'ss_socialmediaposts',
  'ss_socialposts',
  'ss_socials_last_scraped_at',
  'ss_sourcesearchresultid',
  'ss_startedatcurrentcompany',
  'ss_title',
  'ss_titlestartedat',
  'ss_totaltasks',
  'ss_updated_at',
  'ss_updatedat',
  'ss_userid',
  'ss_username',
  'ss_website',
  'ss_website_ds_list',
  'ss_website_links_ds_list',
  'ss_website_scraped_at',
  'ss_websiteaudit',
  'ss_websiteaudit2',
  'ss_websitegrader',
  'ss_websiteuserai_domainid',
  'ss_webtechnologies',
  'ss_whois',
  'ss_wikipedia',
  'ss_yahoofinance',
];
